export enum Language {
  English = 'en',
  Deutsch = 'de',
  Dutch = 'nl',
}
